import { createSelector } from 'reselect';
import _ from 'lodash';

const mapOutcode = ({ area, outcode, city, enabled, not_added }) => ({
  outcode,
  district: outcode,
  town: (city || []).join(', '),
  area: area[0],
  status: enabled[0],
  not_added,
});

export const getOutcodes = createSelector(
  (state) => state.outcodes.data,
  (outcodes) => {
    return outcodes.map(mapOutcode);
  }
);

export const getSelectedOutcodes = createSelector(
  getOutcodes,
  (state) => state.outcodes.selected,
  (outcodes, selectedOutcodes) => {
    return selectedOutcodes.map((outcode) => outcodes.filter((o) => o.outcode === outcode)[0]);
  }
);

export const areSelectedOutcodesAreasHomogeneous = createSelector(
  getSelectedOutcodes,
  (selectedOutcodes) => {
    return _.uniq(selectedOutcodes.map(({ area }) => area)).length === 1;
  }
);

export const getOutcodesFilters = (state) => state.outcodes.filters;

export const geOutcodeNextURL = (state) => state.outcodes.next;
